import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  @Input() titleModal: string = 'Title modal';
  @Input() modalId: string = '';

  @Input() toastMessage: string = '';
  @Input() showToast: boolean = false;
  @Input() isToastError: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xlg' = 'sm'; 
}
